import script from "./existing.vue?vue&type=script&setup=true&lang=js"
export * from "./existing.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__